import { render, staticRenderFns } from "./hedgeParamsModal.vue?vue&type=template&id=47f97c51&scoped=true&"
import script from "./hedgeParamsModal.vue?vue&type=script&lang=js&"
export * from "./hedgeParamsModal.vue?vue&type=script&lang=js&"
import style0 from "./hedgeParamsModal.vue?vue&type=style&index=0&id=47f97c51&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f97c51",
  null
  
)

export default component.exports